import { createPinia } from 'pinia';

// Create a global Pinia instance that will be shared across all custom elements
export const globalPinia = createPinia();
